import type { ListBuilderList } from '../../../types';
import { BASE_FILTER_RULES, TRANSACTION_REQUIRED_FIELDS } from '../shared';

/**
 * Refund transactions list - inherits from all-transactions filtered to Refund transaction type
 */
export const refundTransactionsList: ListBuilderList = {
	id: 'default-transaction-refunds',
	inheritsFrom: 'default-transaction-all',
	cacheTTL: 300000,
	name: 'Refunds',
	type: 'default',
	active: true,
	sortOrder: 6,
	description: 'Refund transactions only',
	defaultSortId: 'column-transaction-dates-desc',
	requiredFields: TRANSACTION_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		transactionType: {
			defaultValue: [{ id: 'Refund', label: 'Refund' }],
		},
	},
};
